import React from 'react';
import { FunnelIcon } from '@heroicons/react/24/outline';

interface FilterButtonProps {
  onClick: () => void;
  isExpanded: boolean;
  hasActiveFilters: boolean;
  className?: string;
  /** When true, shows on all screen sizes. Default is mobile-only. */
  showOnAllScreens?: boolean;
}

/**
 * Reusable filter button component.
 * Shows a funnel icon with an indicator dot when filters are active,
 * and a dropdown arrow that rotates when expanded.
 * By default only shows on mobile, set showOnAllScreens for all breakpoints.
 */
const FilterButton: React.FC<FilterButtonProps> = ({
  onClick,
  isExpanded,
  hasActiveFilters,
  className = '',
  showOnAllScreens = false,
}) => {
  return (
    <button
      data-track="filter_toggle"
      onClick={onClick}
      className={`${showOnAllScreens ? '' : 'md:hidden'} relative inline-flex items-center justify-center w-11 h-11 sm:w-10 sm:h-10 border rounded-md transition-colors ${
        hasActiveFilters
          ? 'bg-primary-50 border-primary-300 text-primary-700'
          : 'bg-surface border-edge-input text-body hover:bg-surface-hover'
      } ${className}`}
      aria-label="Toggle filters"
      aria-expanded={isExpanded}
    >
      <FunnelIcon className="h-5 w-5" />
      {hasActiveFilters && (
        <span className="absolute top-0.5 right-0.5 inline-flex items-center justify-center w-2.5 h-2.5 rounded-full bg-primary-600"></span>
      )}
      <svg
        className={`absolute bottom-0.5 right-0.5 h-2 w-2 transition-transform ${isExpanded ? 'transform rotate-180' : ''}`}
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={3}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
      </svg>
    </button>
  );
};

export default FilterButton;

